import type { ReactNode } from "react";

import { useEnv } from "../env/EnvProvider";
import { useAuth } from "./AuthProvider";

export function AuthGate({ children }: { children: ReactNode }) {
  const { status, signIn } = useAuth();
  const env = useEnv();

  if (status === "loading") {
    return (
      <div className="flex h-full items-center justify-center text-sm text-text-muted">
        Loading…
      </div>
    );
  }

  if (status === "unauthenticated") {
    return (
      <div className="flex h-full items-center justify-center p-6">
        <div className="w-full max-w-sm rounded border border-bg-card-elevated bg-bg-card p-6 text-center">
          <div className="text-base font-semibold text-text-light">
            saltpig Admin
          </div>
          <div className="mt-1 text-xs uppercase tracking-wide text-text-muted">
            {env.label}
          </div>
          <button
            type="button"
            onClick={() => {
              void signIn();
            }}
            className="mt-5 w-full rounded bg-bg-card-elevated px-4 py-2 text-sm font-medium text-text-light hover:opacity-90"
          >
            Sign in with Keycloak
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
